import { isRequired } from '../../helpers/Form'


const topicFields = {
  title: {
    validators: [isRequired]
  },
  content: {},
  featuredMedia: {
    value: null
  },
  embedImages: {
    value: []
  }
}

export default topicFields
